import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppContext } from 'views/App/context';
import DTBPackageList from './List';
import DTBPackageCreate from './New';
import DTBPackageClone from './Clone';
import DetailDtbPackages from './Detail';
import { DTBPackageProvider } from './context';
import SearchInLibrary from './Detail/SearchInLibrary';
import EditProperties from './Detail/EditProperties';

export default function DTBPackages() {
  const { hasAppPermission } = useContext(AppContext);

  const getDefaultRoute = () => {
    if (hasAppPermission('dtbManager')) {
      return <Navigate to='.' />;
    } else {
      return <Navigate to='/dashboard' />;
    }
  };

  return (
    <Routes>
      <Route
        path=':id'
        element={
          <DTBPackageProvider>
            <DetailDtbPackages />
          </DTBPackageProvider>
        }
      />
      <Route
        path=':id/search'
        element={
          <DTBPackageProvider>
            <SearchInLibrary />
          </DTBPackageProvider>
        }
      />
      <Route
        path='new'
        element={<DTBPackageCreate />}
      />
      <Route
        path=':id/edit-properties'
        element={
          <DTBPackageProvider>
            <EditProperties />
          </DTBPackageProvider>
        }
      />
      <Route
        path=':id/clone'
        element={<DTBPackageClone />}
      />
      <Route
        index
        element={<DTBPackageList />}
      />
      <Route
        path='*'
        element={getDefaultRoute()}
      />
    </Routes>
  );
}
